module.exports = __webpack_public_path__ + "assets/img/robyn_searle_1.04ec5cd2.png";